<template>
  <div class="space-y-4">
    <cms-rich-text
      :class="{ 'line-clamp-1': !showExpandedRichText }"
      :content="{ richText: showExpandedRichText ? expandedRichText : richText }"
      :links-hover-color="hoverLinkColor || textColor"
    />
    <template v-if="showCtas">
      <div v-for="(target, targetIdx) in targets" :key="targetIdx" class="lg:w-fit">
        <cms-shared-button v-bind="target" class="w-full" :style="{ sm: 'primary' }" @click="$emit('resolve')" />
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { Message } from '#types/components/cms/promo-bar'

const { content } = defineProps<{ content: Message }>()
defineEmits<{ resolve: [] }>()

const { richText, targets, expandedRichText, hoverLinkColor, textColor, showExpandedRichText, showCtas } = content
</script>
